import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Img, RedactContext, RedactOverlay, StatusBadge } from "@/components/common";
import { useSite } from "@/lib/site";
import { cn } from "@/lib/utils";

export const ProjectCard = ({ project, index, className, imageClass = "aspect-[4/3]", showTagline }) => {
  const { catById } = useSite();
  const confidential = project.status === "CONFIDENTIAL";
  const cats = project.category_ids.map((id) => catById[id]?.name).filter(Boolean);
  return (
    <Link to={`/work/${project.slug}`} data-testid={`project-card-${project.slug}`} className={cn("group block", className)}>
      <RedactContext.Provider value={confidential}>
        <div className={cn("relative overflow-hidden rounded-md bg-surface", imageClass)}>
          <Img
            src={project.cover_image}
            alt={confidential ? "Confidential project cover (obscured)" : project.image_alt || `${project.name} cover`}
            sizes="(max-width: 768px) 100vw, 50vw"
            className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-[1400ms] ease-out group-hover:scale-[1.045]"
          />
          {confidential && <RedactOverlay compact />}
          <div className="absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-black/50 to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
          <StatusBadge status={project.status} className="absolute left-4 top-4 z-20" />
          {index !== undefined && <span className="absolute right-4 top-4 z-20 font-mono text-[11px] text-white/80">{String(index + 1).padStart(2, "0")}</span>}
        </div>
      </RedactContext.Provider>
      <div className="mt-5 flex items-start justify-between gap-6">
        <div className="min-w-0">
          <p className="label-mono truncate" data-testid="card-category-label">{cats.join(" · ")}</p>
          <h3 className="mt-2 font-display text-2xl leading-tight transition-colors duration-300 group-hover:text-turq md:text-3xl">{project.name}</h3>
          {showTagline && <p className="mt-2 max-w-md text-sm leading-relaxed text-silver">{project.tagline}</p>}
        </div>
        <ArrowUpRight className="mt-6 h-5 w-5 shrink-0 text-gold transition-transform duration-500 group-hover:rotate-45" aria-hidden />
      </div>
    </Link>
  );
};
